/**
 @ngdoc directive
 @name communicationFilterSidebar

 @description
 Sidebar with filters for Comms Management page

 @usage
 <communication-filter-sidebar
     tile-model="tileModel"
     common-label="ctrl.dataResponse.data.labels.common"
     object-label="ctrl.dataResponse.data.labels.commsManagement"
     filters="ctrl.filters"
     type-filters="ctrl.typeFilters"
     status-filters="ctrl.statusFilters"
     current-page="ctrl.currentPage"></communication-filter-sidebar>

 @param {array}  tile-model                       - (passing time model)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {array}  common-label                     - (passing common labels)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {array}  object-label                     - (passing object labels)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {array}  filters                          - (passing all filters)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {string}  type-filters                     - (passing type specific filters)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {string}  status-filters                   - (passing status specific filters)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {string}  user-filters                   - (passing user specific filters)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {integer}  current-page                    - (passing current page number)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {array}  time-filters                    - (passing array of time filters)parameter used to communication between communicationFitlerSidebar & communicationTile directives
 @param {string}  selected-time-filter           - (passing default selected time filter)parameter used to communication between communicationFitlerSidebar & communicationTile directives

 */

(function() {
    'use strict';
    var communicationFilterSidebar = function ($templateCache) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            bindToController: {
                tileModel: '=',
                pagination: '=',
                commonLabel: '=',
                objectLabel: '=',
                searchFilter: '=',
                timeFilters: '=',
                filtersByType: '='
            },
            controllerAs: 'ctrl',
            scope: true,
            template: $templateCache.get('components/communicationFilterSidebar.html'),
            controller: ['$scope', '$element', '$attrs', function($scope /*, $element, $attrs */){
                var _this = this;
                _this.debug = false;
                _this.expandCollapseAll = false;

                // Function to toggle collapse on filter types in sidebar
                $scope.expandCollapseAll = function() {
                    if(!_this.expandCollapseAll){
                        _this.filterCollapseMedium = true;
                        _this.filterCollapseStatus = true;
                        _this.filterCollapseUsers = true;
                        _this.filterCollapseTime = true;
                        _this.filterCollapseXmsType = true;
                        _this.filterCollapseCommsType = true;
                    }else{
                        _this.filterCollapseMedium = false;
                        _this.filterCollapseStatus = false;
                        _this.filterCollapseUsers = false;
                        _this.filterCollapseTime = false;
                        _this.filterCollapseXmsType = false;
                        _this.filterCollapseCommsType = false;
                    }
                    _this.expandCollapseAll= !_this.expandCollapseAll;
                };
                $scope.expandCollapseAll();
            }]
        };
    };

    communicationFilterSidebar.$inject = ['$templateCache'];
    angular.module('app').directive('communicationFilterSidebar', communicationFilterSidebar);

}());
